export function batchProgress(batch, sample, now = Date.now()) {
  const total = Math.max(0, Number(batch?.total) || 0);
  const processed = Math.min(total, Math.max(0, Number(batch?.processed) || 0));
  const percent = total ? Math.round((processed / total) * 100) : 0;
  let estimate = 'Calculando estimativa conforme as consultas avançam…';
  if (batch?.status === 'paused')
    estimate = 'Pausado. A estimativa será recalculada ao retomar.';
  else if (['completed', 'partial_success'].includes(batch?.status))
    estimate = 'Processamento finalizado.';
  else if (['failed', 'timeout', 'cancelled'].includes(batch?.status))
    estimate = 'Processamento encerrado.';
  else if (batch?.status !== 'processing')
    estimate = 'Aguardando início do processamento.';
  else if (
    sample?.id === batch?.id &&
    processed > sample.processed &&
    now > sample.at
  ) {
    const seconds = Math.ceil(
      ((total - processed) * (now - sample.at)) /
        (processed - sample.processed) /
        1000
    );
    const minutes = Math.ceil(seconds / 60);
    estimate =
      seconds < 60
        ? 'Estimativa: menos de 1 minuto restante.'
        : `Estimativa: cerca de ${minutes} min restantes.`;
  }
  return { total, processed, percent, estimate };
}
